import React from "react";
import classNames from "classnames";
import { injectIntl } from "react-intl";
import Icon from "./Icon";
var SocialAppFooter = function(param) {
    var _param_hero = param.hero, hero = _param_hero === void 0 ? false : _param_hero, _param_buttons = param.buttons, buttons = _param_buttons === void 0 ? {} : _param_buttons, intl = param.intl;
    var _buttons_leftButton, _buttons_rightButton;
    var classes = classNames("social-app-footer", {
        "social-app-footer--hero": hero
    });
    var leftButtonMode = ((_buttons_leftButton = buttons.leftButton) === null || _buttons_leftButton === void 0 ? void 0 : _buttons_leftButton.mode) || "danger";
    var rightButtonMode = ((_buttons_rightButton = buttons.rightButton) === null || _buttons_rightButton === void 0 ? void 0 : _buttons_rightButton.mode) || "success";
    var leftButtonClassNames = classNames("social-app-footer__button", {
        "social-app-footer__button--danger": leftButtonMode === "danger",
        "social-app-footer__button--success": leftButtonMode === "success"
    });
    var rightButtonClassNames = classNames("social-app-footer__button social-app-footer__button--right", {
        "social-app-footer__button--danger": rightButtonMode === "danger",
        "social-app-footer__button--success": rightButtonMode === "success"
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: classes
    }, buttons.leftButton && /*#__PURE__*/ React.createElement("button", {
        className: leftButtonClassNames,
        onClick: buttons.leftButton.action
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "close-line",
        size: "m"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "social-app-footer__button-text"
    }, buttons.leftButton.title || intl.formatMessage({
        id: "social.activities.cancel",
        defaultMessage: "Cancel"
    }))), buttons.rightButton && /*#__PURE__*/ React.createElement("button", {
        className: rightButtonClassNames,
        onClick: buttons.rightButton.action
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "save",
        size: "m"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "social-app-footer__button-text"
    }, buttons.rightButton.title || intl.formatMessage({
        id: "social.activities.save",
        defaultMessage: "Save"
    }))));
};
export default injectIntl(SocialAppFooter);
